import React from 'react';
import { BarChart } from 'react-native-chart-kit';
import { View, Text } from 'react-native';
import LottieView from 'lottie-react-native';
import { themeSelector } from '@reduxLocal/selectors/themeSelector';
import { MODERN_CHART_COLORS } from '@utils/chartTheme';
import ModernChartWrapper from './ModernChartWrapper';

interface MonthlyBarChartProps {
  data?: any;
  isLoading?: boolean;
  chartConfig?: any;
  width?: number;
  height?: number;
}

const MonthlyBarChart: React.FC<MonthlyBarChartProps> = ({
  data,
  isLoading = false,
  chartConfig,
  width = 280,
  height = 180
}) => {
  const theme = themeSelector();
  const summaryData = [
    { label: 'This Month', value: '2.4K', color: MODERN_CHART_COLORS.bar.primary },
    { label: 'Last Month', value: '1.8K', color: MODERN_CHART_COLORS.bar.secondary },
    { label: 'Growth', value: '+33%', color: MODERN_CHART_COLORS.bar.tertiary }
  ];

  const loadingComponent = (
    <LottieView
      style={{ height: 150, alignSelf: 'center' }}
      source={require("@assets/animations/spin-leaf-loader.json")}
      autoPlay
      loop
    />
  );

  return (
    <ModernChartWrapper
      title="Monthly Trends"
      subtitle="Track your monthly performance"
      isLoading={isLoading}
      loadingComponent={loadingComponent}
      summaryData={summaryData}
      minHeight={320}
      minWidth={340}
    >
      {data ? (
        <BarChart
          data={data}
          width={width}
          height={height}
          chartConfig={chartConfig}
          style={{ borderRadius: 10 }}
          showValuesOnTopOfBars
          yAxisLabel=""
          yAxisSuffix=""
        />
      ) : (
        <View style={{
          height: height,
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Text style={{ color: theme ? '#64748b' : '#94a3b8' }}>
            No monthly data available
          </Text>
        </View>
      )}
    </ModernChartWrapper>
  );
};

export default MonthlyBarChart;
